import React from 'react';
import { ButtonContainer } from './BorderlessButton.styles';

export interface BorderlessButtonProps {
  /**
   * Button content
   */
  children: React.ReactNode;
  /**
   * Optional onClick handler
   */
  onClick?: () => void;
  /**
   * Additional class name
   */
  className?: string;
  /**
   * Button variant
   */
  $variant?: 'underlined';
}

/**
 * Borderless button component with text-only appearance
 * Always full width and enabled
 */
export const BorderlessButton: React.FC<BorderlessButtonProps> = ({
  children,
  onClick,
  $variant,
  className = '',
}) => {
  return (
    <ButtonContainer
      onClick={onClick}
      $variant={$variant}
      className={className}
    >
      {children}
    </ButtonContainer>
  );
};

export default BorderlessButton;
